import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { tap } from "rxjs/operators";
import { Supplier } from "../../supplier/supplier";
import { NewSupplierReferenceRequest } from "../new-supplier-reference-request";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";
import { SupplierReference } from "../supplier-reference";

@Component({
  styleUrls: ["./switch-supplier-dialog.component.css"],
  templateUrl: "./switch-supplier-dialog.component.html"
})
export class SwitchSupplierDialogComponent implements OnInit {
  reference!: Reference;
  supplier!: Supplier;
  activeSupplierReference!: SupplierReference;

  newSupplier!: Supplier;

  public onSupplierReferenceUpdate!: (reference: Reference) => void;

  public onSupplierSelected = (supplier: Supplier) => this.newSupplier = supplier;

  price!: number;
  newSupplierReferenceRequest = new NewSupplierReferenceRequest();

  constructor(
    public modal: NgbActiveModal,
    private referenceService: ReferenceService
  ) { }

  switchSupplier() {
    this.newSupplierReferenceRequest.price = this.price * 100;
    this.referenceService.switchSupplier(this.reference.isbn, this.newSupplier.id).pipe(
      tap(_ => this.modal.close()),
      tap(reference => this.onSupplierReferenceUpdate(reference)),
    ).subscribe();
  }

  ngOnInit() {
    this.newSupplierReferenceRequest.isbn = this.reference.isbn;
    this.newSupplierReferenceRequest.supplierId = this.supplier.id;
    if (this.activeSupplierReference != undefined) {
      this.newSupplierReferenceRequest.supplierId = this.activeSupplierReference.supplier.id;
    }
  }

}